import { RootState, useAppDispatch, useAppSelector } from 'common';
import { RecipeCustomerShare } from 'common/src/api/models/recipe-customer-share.models';
import {
  getRecipeCustomerShares,
  selectAllRecipeCustomerShareData,
  selectAllRecipeCustomerShares,
} from 'common/src/store/recipes';
import { useEffect, useState } from 'react';
import { CfDataGridProps } from '../../../../cf-ui/DataGrid/CfDataGridProps';
import { CfDataGridContainer } from '../../../../cf-ui/DataGridContainer/CfDataGridContainer';
import { StyledViewBox } from '../../../_shared/components/shared-styled-components.styles';
import RecipeCustomerShareDialog, {
  RecipeCustomerShareDialogProps,
} from '../../../recipes/components/RecipeCustomerShareDialog/RecipeCustomerShareDIalog';
import { locationsTableView } from '../../components/gridTablesView/LocationsTableView';
import { ManageAccessTableHeader } from '../../components/headers/ManageAccessTableHeader';

export default function Locations(): JSX.Element {
  const dispatch = useAppDispatch();

  const [searchParam, setSearchParam] = useState('');
  const [shareRecipeDialog, setShareRecipeDialog] = useState<RecipeCustomerShareDialogProps | undefined>(undefined);

  const customerId = useAppSelector((s) => s.customer.selectedCustomer?.CustomerId) || '';
  const userCustomers = useAppSelector((s: RootState) => s.user.userSite?.UserCustomers || []);
  const recipeShares = useAppSelector((s) => selectAllRecipeCustomerShares(s.recipes.recipeCustomerShares));
  const filteredRecipeShares = useAppSelector((s) => selectAllRecipeCustomerShareData(s, searchParam));
  const isLoading = useAppSelector((s) => s.recipes.isRecipeCustomerSharesLoading);

  useEffect(() => {
    dispatch(getRecipeCustomerShares(customerId));
  }, []);

  const handleManageLocation = () => {
    setShareRecipeDialog({
      customerId,
      userCustomers,
      onClose: () => setShareRecipeDialog(undefined),
    });
  };

  const dataGridProps: CfDataGridProps<RecipeCustomerShare> = {
    id: 'recipeWorkSheetGrid',
    tableView: locationsTableView(),
    selectId: (item: RecipeCustomerShare) => item.SharedWithCustomerId,
    displayMode: 'table',
    autoFocus: 'firstNavigableElement',
    noItemsMessage: 'No locations found',
    data: {
      pages: [
        {
          items: filteredRecipeShares,
          pageIndex: 0,
          isLoading: isLoading,
          pageSize: isLoading ? 4 : filteredRecipeShares.length,
        },
      ],
      totalPageCount: 1,
      totalItemCount: recipeShares.length,
      pagingMode: 'none',
    },
  };

  return (
    <StyledViewBox>
      <CfDataGridContainer
        dataGridProps={dataGridProps}
        sx={{
          '& .css-nsyoup-MuiCardContent-root': {
            padding: 0,
            margin: 0,
          },
        }}
        controlsContainerSx={{ padding: 0, margin: 0 }}
        customControlsContainer={
          <ManageAccessTableHeader
            title='Locations'
            description='Manage locations that can view all recipes.'
            searchPlaceholder='Search locations'
            setSearchParam={setSearchParam}
            handleDialog={handleManageLocation}
            isManageLocation={true}
          />
        }
      />
      {shareRecipeDialog && <RecipeCustomerShareDialog {...shareRecipeDialog} />}
    </StyledViewBox>
  );
}
